import { createContext } from "react";

const NightmodeContext = createContext();

NightmodeContext.displayName = "NightmodeContext";

export default NightmodeContext;
